// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"499":"b49d0a48","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"499":"6b35a00a663b2a68593c","691":"867622106c3e09908e74"}[chunkId] + ".js";
};